
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_o08jm_7q2m6_9",
  "root-horizontal": "awsui_root-horizontal_o08jm_7q2m6_41",
  "root-vertical": "awsui_root-vertical_o08jm_7q2m6_46",
  "layout": "awsui_layout_o08jm_7q2m6_51",
  "action-slot": "awsui_action-slot_o08jm_7q2m6_56",
  "layout-horizontal": "awsui_layout-horizontal_o08jm_7q2m6_64",
  "layout-vertical": "awsui_layout-vertical_o08jm_7q2m6_71",
  "control": "awsui_control_o08jm_7q2m6_79",
  "control-middle-horizontal": "awsui_control-middle-horizontal_o08jm_7q2m6_86",
  "control-last-horizontal": "awsui_control-last-horizontal_o08jm_7q2m6_86",
  "control-middle-vertical": "awsui_control-middle-vertical_o08jm_7q2m6_89",
  "control-last-vertical": "awsui_control-last-vertical_o08jm_7q2m6_89",
  "inline-label": "awsui_inline-label_o08jm_7q2m6_93",
  "inline-label-wrapper": "awsui_inline-label-wrapper_o08jm_7q2m6_118",
  "inline-label-trigger-wrapper": "awsui_inline-label-trigger-wrapper_o08jm_7q2m6_123"
};
  